import React from 'react';
import { MyDataGrid } from '../../../common/components';

export default function ReferralsTable({
  ...others
}) {
  return (
    <MyDataGrid
      showToolbar={true}
      minTableHeight={'calc(100vh - 192px)'}
      getRowId={row => row.id}
      {...others}
    />
  );
}
